import React, { Fragment } from 'react'
import Panel from '../../UniformComponents/Panel'
import Button from '../../UniformComponents/Button'

const NoDashboardsView = ({ dashStore, showCreateWidget }) => {
    const { toggleShowCreateDashboard, dashboard } = dashStore
    const { appStore } = dashStore
    const { userData } = appStore
    const { role } = userData

    if ([150, 170].includes(role)) {
        return (
            <div className="noDashboards">
                <Panel>
                    <Fragment>
                        <div className="noDashboards-header">
                            <img style={{ width: '450px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/noDashboards.svg`} />
                            {dashboard.value === 'new'
                                ? <h3>You do not currently have any dashboards available</h3>
                                : <h3>There are currently no widgets available for this dashboard</h3>}
                        </div>
                    </Fragment>
                </Panel>
            </div>
        )
    }

    return (
        <div className="noDashboards">
            <Panel>
                {dashboard.value === 'new'
                    ? (
                        <Fragment>
                            <div className="noDashboards-header">
                                <img style={{ width: '450px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/noDashboards.svg`} />
                                <h3>Get started with dashboards</h3>
                                <div className="subtitle">
                                    Select the button below to get started
                                    <br />
                                </div>
                            </div>
                            <div className="controls">
                                {/* <Button
                                    label="Select a template"
                                    icon="fa-light fa-gauge-simple-max"
                                    cssClass="secondary regular"
                                    style={{ fontWeight: 600, padding: '10px 40px' }}
                                /> */}
                                <Button
                                    label="Start from scratch"
                                    icon="fa-light fa-circle-plus"
                                    cssClass="primary regular"
                                    style={{ fontWeight: 600, padding: '10px 40px' }}
                                    onClick={toggleShowCreateDashboard}
                                />
                            </div>
                        </Fragment>
                    )
                    : (
                        <Fragment>
                            <div className="noDashboards-header">
                                <img style={{ width: '750px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/blankDashboard.svg`} />
                                <h3>Start building your dashboard</h3>
                                <div className="subtitle">
                                    Use charts and other widgets to visualise your event KPIS
                                </div>
                            </div>
                            <div className="controls">
                                <Button
                                    label="Add your first widget"
                                    icon="fa-light fa-circle-plus"
                                    cssClass="primary regular"
                                    style={{ fontWeight: 600, padding: '10px 40px' }}
                                    onClick={showCreateWidget}
                                />
                            </div>
                        </Fragment>
                    ) }
            </Panel>
        </div>
    )
}

export default NoDashboardsView
